import React from "react";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useAccentColor } from "utils/accent-color";
import { formatEyebrowNumber } from "../knowledge-base-hub/knowledge-filters";

const ChapterHeader = ({ chapter, number, articles, nextUnread, onBack, onOpen }) => {
  const accent = useAccentColor(chapter.color_code);
  const total = articles.length;
  const read = articles.filter((a) => a.viewer_state?.has_viewed).length;
  const pct = total ? Math.round((read / total) * 100) : 0;

  return (
    <div className="rounded-2xl border border-border bg-surface p-4 sm:p-6">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex items-center gap-1.5 mb-4 text-xs font-medium text-text_secondary cursor-pointer"
      >
        <ArrowLeft size={13} /> Knowledge Base
      </button>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        <div
          className="flex-shrink-0 w-14 h-14 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center font-mono text-xl sm:text-3xl font-bold"
          style={{ backgroundColor: accent.fill, color: accent.text }}
        >
          {formatEyebrowNumber(number)}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-mono text-[10.5px] uppercase tracking-[0.2em]" style={{ color: accent.text }}>
            Chapter {number}
          </p>
          <h1 className="mt-1 text-xl sm:text-2xl font-bold text-text_primary leading-tight">{chapter.title}</h1>
          {chapter.description && (
            <p className="mt-2 text-[13px] text-text_secondary leading-relaxed max-w-2xl">{chapter.description}</p>
          )}
          <div className="mt-3 flex items-center gap-3">
            <div className="h-1.5 w-32 sm:w-56 rounded-full bg-surface_alt overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: accent.base }} />
            </div>
            <span className="font-mono text-[11px] text-text_muted">
              {read} / {total} read
            </span>
          </div>
        </div>
        {nextUnread && (
          <button
            type="button"
            onClick={() => onOpen(nextUnread.id)}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl text-white text-sm font-semibold cursor-pointer self-start sm:self-center"
            style={{ backgroundColor: accent.base }}
          >
            Next unread <ArrowRight size={15} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ChapterHeader;
